import { defineStore } from "pinia";

import type { Company } from "@/model/company";

export const useCompanyStore = defineStore("company", {
  state: () => ({ name: "", shouldOnboard: false }),

  actions: {
    setCompany(company: Company) {
      this.$patch(company);
    },
  },
});
